import { render, staticRenderFns } from "./index.vue?vue&type=template&id=73ba52ae&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=73ba52ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ba52ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ba52ae')) {
      api.createRecord('73ba52ae', component.options)
    } else {
      api.reload('73ba52ae', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=73ba52ae&scoped=true&", function () {
      api.rerender('73ba52ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/error/404/index.vue"
export default component.exports